<template>
  <div class="form-family-sick" v-if="project != null">
    <h1>Condiciones para el teletrabajo</h1>
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Mensaje</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div :class="`alert ${typeMessage}`" role="alert" id="message-update" v-if="message != ''">
              {{message}}
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>    
    <table class="table" >
      <thead>
      </thead>
      <tbody>
        <div class="" v-for="(aspects,idx) in Object.keys(form)" :key="idx">
          <div class="" v-for="(aspect,idx2) in form[aspects]" :key="idx2">
            <div class="card" style="width: 100%;">
              <div class="card-body">
                <h4 style="text-align: left;">{{aspect.name}}</h4>
                <div class="" v-for="(condition,idx3) in aspect.conditions" :key="idx3">
                  <h6>{{condition.name}}</h6>
                  <div class="" v-for="(question,idx4) in condition.questions" :key="idx4">
                    <div class="question-text" v-if="question.type === 'text'">
                      <label for="">{{question.text}}</label>
                      <input type="text" class="form-control" :id="workingCondition[question.field]" placeholder="" v-model="workingCondition[question.field]">
                      <p></p>
                    </div>
                    <p></p>
                    <div class="question-boolean" v-if="question.type === 'checkbox'">
                      <input type="checkbox" class="form-check-input" id="has_incapacitate_disease" v-model="workingCondition[question.field]">
                      <template v-if ="workingCondition[question.field]">
                        Si.
                      </template>
                      <template v-if ="!workingCondition[question.field]">
                        No.
                      </template>                      
                      <label class="form-check-label" for="exampleCheck1">{{question.text}}. (marque ✔ en caso de ser afirmativo)</label>
                      <p></p>
                    </div>
                  </div>
                  <button @click.prevent="create" v-if="mode == 'create'" type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal">
                    Guardar
                  </button>
                  <hr>
                </div>
              </div>
            </div>            
          </div>
        </div>
      </tbody>
    </table>
    <b-button variant="primary" @click.prevent="create" v-if="mode == 'create'">Guardar</b-button>
    <b-button variant="primary" @click.prevent="update" v-if="mode == 'update'">Editar</b-button>
		<div :class="`alert ${typeMessage}`" role="alert" id="message-update" v-if="message != ''">
			{{message}}
		</div>    
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios';
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'FormworkingCondition',
  props: ['project_id', 'assignment_id'],  
  computed: {
    ...mapGetters(['projectId', 'assignmentId', 'project', 'assignment', 'selects'])
  },  
  data() {
    return {
			message: '',
      typeMessage: '',
      workingCondition: { id: null},
      mode: 'create',
      form: {
        'aspects_inspect': [
          {
            'name': 'CONDICIONES LOCATIVAS',
            'conditions': [
              {
                name: 'Techos',
                questions: [
                  {
                    'text': 'El techo del área de trabajo, ¿está en buenas condiciones?',
                    'field': 'ceiling_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Describa el tipo de material y si presenta alguna irregularidad.',
                    'field': 'ceiling_description',
                    'type': 'text'
                  },
                  {
                    'text': 'Los objetos colgados en el techo del área de trabajo, ¿están anclados de forma segura?',
                    'field': 'ceiling_objects_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'observaciones',
                    'field': 'ceiling_objects_description',
                    'type': 'text'
                  }                  
                ]
              },
              {
                name: 'Paredes',
                questions: [
                  {
                    'text': 'Las paredes del área de trabajo, ¿están en buenas condiciones?',
                    'field': 'walls_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Observaciones',
                    'field': 'walls_description',
                    'type': 'text'
                  },
                  {
                    'text': 'Los objetos colgados en las paredes del área de trabajo, ¿están anclados de forma segura?',
                    'field': 'walls_objects_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Observaciones',
                    'field': 'walls_objects_description',
                    'type': 'text'
                  }                                    
                ]
              },
              {
                name: 'Pisos',
                questions: [
                  {
                    'text': 'Los pisos del área de trabajo, ¿son planos?',
                    'field': 'flat_floor_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Observaciones',
                    'field': 'flat_floor_description',
                    'type': 'text'
                  },
                  {
                    'text': 'Los pisos del área de trabajo, ¿están libres de obstáculos?',
                    'field': 'free_floor_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Observaciones',
                    'field': 'free_floor_description',
                    'type': 'text'
                  },
                  {
                    'text': 'El material del piso del área de trabajo, ¿está en buenas condiciones?',
                    'field': 'material_floor_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Describa el tipo de material (cerámica, madera, alfombra, etc.)',
                    'field': 'material_floor_description',
                    'type': 'text'
                  },
                  {
                    'text': 'El piso del área de trabajo, ¿permite la adecuada movilidad de la silla?',
                    'field': 'chair_mobility_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Observaciones',
                    'field': 'chair_mobility_description',
                    'type': 'text'
                  }                  
                ]
              },
              {
                name: 'ACCESO AL ÁREA DE TRABAJO',
                questions: [
                  {
                    'text': 'Las puertas y ventanas del área de trabajo, ¿están en buenas condiciones?',
                    'field': 'windows_doors_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Observaciones',
                    'field': 'windows_doors_description',
                    'type': 'text'
                  },
                  {
                    'text': 'Las puertas y ventanas del área de trabajo, ¿tienen normal funcionamiento?',
                    'field': 'windows_doors_work_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Observaciones',
                    'field': 'windows_doors_work_description',
                    'type': 'text'
                  },
                  {
                    'text': '¿El ingreso al área de trabajo es seguro?',
                    'field': 'entry_safe_work_area_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Describa tipo de acceso (escaleras, corredor, rampa, balcón, etc)',
                    'field': 'entry_safe_work_area_description',
                    'type': 'text'
                  },
                  {
                    'text': 'Las escaleras, balcones y/o corredores de acceso al área de trabajo, ¿cumplen con pasamanos, bandas o piso antideslizante?',
                    'field': 'entry_work_area_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Observaciones',
                    'field': 'entry_work_area_description',
                    'type': 'text'
                  },
                  {
                    'text': 'La escalera de acceso al área de trabajo, ¿tiene material o diseño antideslizante?',
                    'field': 'stairs_conditions',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Observaciones',
                    'field': 'stairs_description',
                    'type': 'text'
                  },
                  {
                    'text': 'La huella en las escalas, ¿es adecuada y lebrinda seguridad al empleado?',
                    'field': 'stairs_anti_slip_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Observaciones',
                    'field': 'stairs_anti_slip_description',
                    'type': 'text'
                  }                  
                ]
              },
              {
                name: 'CONDICIONES DE ILUMINACIÓN',
                questions: [
                  {
                    'text': 'La iluminación natural del área de trabajo, ¿es adecuada y suficiente para la labor de Teletrabajo?',
                    'field': 'lighting_adequate_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Observaciones',
                    'field': 'lighting_adequate_description',
                    'type': 'text'
                  },
                  {
                    'text': 'Las lámparas del área de trabajo, ¿se encuentran limpias y reflejan buena luz?',
                    'field': 'lighting_clean_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Observaciones',
                    'field': 'lighting_clean_description',
                    'type': 'text'
                  },
                  {
                    'text': 'La luz natural y/o artificial, ¿permite visualizar la pantalla del computador sin reflejos por vidrios u otros?',
                    'field': 'lighting_without_reflections_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Observaciones',
                    'field': 'lighting_without_reflections_description',
                    'type': 'text'
                  }                                    
                ]
              }
            ]
          },
          {
            name: 'CONDICIONES DE RUIDO',
            conditions: [
              {
                name: 'RUIDO',
                questions: [
                  {
                    'text': 'El área de trabajo, ¿posee fuentes internas de ruido?',
                    'field': 'noise_work_area_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Describirlas si la respuesta es afirmativa.',
                    'field': 'noise_work_area_description',
                    'type': 'text'
                  },
                  {
                    'text': 'El ruido externo producido por vehículos, vecinos, comercio, residencias, etc., ¿permite realizar las operaciones de trabajo sin interferencia?',
                    'field': 'external_noise_allows_work_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Observaciones',
                    'field': 'external_noise_allows_work_description',
                    'type': 'text'
                  }                                    
                ]
              }                            
            ]
          },
          {
            name: 'CONDICIONES ERGONÓMICAS',
            conditions: [
              {
                name: 'POSTURA',
                questions: [
                  {
                    'text': '¿Cuáles son las dimensiones del escritorio y/o área de trabajo?',
                    'field': 'desktop_dimensions',
                    'type': 'text'
                  }                      
                ]
              }                            
            ]
          },
          {
            name: 'CONTROL DE RIESGOS',
            conditions: [
              {
                name: 'INCENDIOS EXPLOSIONES EVACUACIÓN',
                questions: [
                  {
                    'text': 'El empleado, ¿tiene conocimiento del procedimiento a seguir en caso de presentarse una emergencia por incendio?',
                    'field': 'fire_knowledge_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Observaciones',
                    'field': 'fire_knowledge_description',
                    'type': 'text'
                  },
                  {
                    'text': 'La ruta de evacuación, ¿está libre de objetos que obstaculicen la salida en caso de emergencia?',
                    'field': 'evacuation_route_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Observaciones',
                    'field': 'evacuation_route_description',
                    'type': 'text'
                  },
                  {
                    'text': 'En la vivienda y/o el área de trabajo, ¿hay de almacenamiento de líquidos o sólidos combustibles?',
                    'field': 'inflammable_store_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Describirlos si la respuesta es afirmativa.',
                    'field': 'inflammable_store_description',
                    'type': 'text'
                  }                                                      
                ]
              },
              {
                name: 'RIESGOS BIOLÓGICOS',
                questions: [
                  {
                    'text': 'El manejo de las basuras y residuos, ¿es adecuado para que no interfiera con el área de trabajo?',
                    'field': 'garbage_handling_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Observaciones',
                    'field': 'garbage_handling_description',
                    'type': 'text'
                  },
                  {
                    'text': 'En el área de trabajo, ¿hay presencia de actividades de tipo hospitalario?',
                    'field': 'clinical_material_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Describirlas si la respuesta es afirmativa.',
                    'field': 'clinical_material_description',
                    'type': 'text'
                  },
                  {
                    'text': '¿Se realizan fumigaciones periódicas para control de insectos, larva y roedores?',
                    'field': 'fumigations_periodic_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Describir la periodicidad de las fumigaciones.',
                    'field': 'fumigations_periodic_description',
                    'type': 'text'
                  }                                                      
                ]
              }              
            ]
          },
          {
            name: 'REDES ELÉCTRICAS',
            conditions: [
              {
                name: 'CABLEADO ELÉCTRICO',
                questions: [
                  {
                    'text': 'Las instalaciones eléctricas del área de trabajo, ¿se observan en buenas condiciones?',
                    'field': 'electrical_instalations_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Observaciones',
                    'field': 'electrical_instalations_description',
                    'type': 'text'
                  },
                  {
                    'text': '¿Cuál es la distancia entre el módem y el lugar donde se ubicaría el puesto de trabajo? Especificar si la distancia incluye uno o dos pisos.',
                    'field': 'modem_distance',
                    'type': 'text'
                  },
                  {
                    'text': '¿Cuántas tomas eléctricas hay en el área de trabajo y qué distancia tienen?',
                    'field': 'electrical_outlets_number_description',
                    'type': 'text'
                  },
                  {
                    'text': 'Las instalaciones eléctricas en el área de trabajo, ¿tienen conexión a tierra?',
                    'field': 'ground_pole_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Observaciones',
                    'field': 'ground_pole_description',
                    'type': 'text'
                  },
                  {
                    'text': '¿Hay presencia de sobre-cargas eléctricas en el área de trabajo?',
                    'field': 'electrical_overloads_presence_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Observaciones',
                    'field': 'electrical_overloads_presence_descriptio',
                    'type': 'text'
                  },
                  {
                    'text': 'Las instalaciones eléctricas del área de trabajo, ¿tienen los cables canalizados?',
                    'field': 'gutters_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Observaciones',
                    'field': 'gutters_description',
                    'type': 'text'
                  },
                  {
                    'text': '¿Hay presencia de empalmes en cables eléctricos en el área de trabajo?',
                    'field': 'electrical_connectors_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Observaciones',
                    'field': 'electrical_connectors_description',
                    'type': 'text'
                  },
                  {
                    'text': 'La caja de interruptores, ¿se encuentra cubierta?',
                    'field': 'box_cover_condition',
                    'type': 'checkbox'
                  },
                  {
                    'text': 'Observaciones',
                    'field': 'box_cover_description',
                    'type': 'text'
                  }                  
                ]
              },
              {
                name: 'INTERNET',
                questions: [
                  {
                    'text': '¿Qué velocidad de bajada tiene Internet? Durante la visita se realizará la prueba de velocidad de internet.',
                    'field': 'internet_speed',
                    'type': 'text'
                  }                                                      
                ]
              }              
            ]
          },                    
        ]
      }
    }
  },
  components: {
  },  
  methods: {
    ...mapMutations(['changeProjectId', 'changeAssignmentId', 'changeProject', 'changeAssignment', 'changeSelects']),
    maskName(attribute, value, itemSearch){
      if (value != null && value != "") {
        return this.selects[attribute].filter(obj => obj[itemSearch] == value)[0].name
      }else{
        return 'N/A'
      }      
    },
    clear(){
      this.workingCondition = { id: null}
      this.mode = 'create'
    },
    defaultAxios(){
			var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
			axios.defaults.headers['x-csrf-token'] = token
			axios.defaults.headers.common['Accept'] = 'application/json';
			axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    },
    getInformationWork() {
			axios.get(`/information_work.json?project_id=${this.projectIdProp}&assignment_id=${this.assignmentIdProp}`).then(res=>{
				if(res.status == 200){
          this.changeProject(res.data.project)
          this.changeAssignment(res.data.assignment)
          this.changeSelects(res.data.selects)
				}
			})
    },
    getWorkingCondition() {
			axios.get(`/information_work.json?project_id=${this.projectIdProp}&assignment_id=${this.assignmentIdProp}`).then(res=>{
				if(res.status == 200){
          if (res.data.project.working_condition != null) {
            this.workingCondition = res.data.project.working_condition
          }
				}
			})
    },    
    editworkingCondition(working_condition){
      this.workingCondition = working_condition
      this.mode = 'update'
    },
    create(){
      this.defaultAxios()
      delete this.workingCondition.id
			axios.post(`/workflow/working_conditions`, { id: this.projectIdProp, working_condition: this.workingCondition }).then(res=>{
				if(res.status == 200){
          this.getInformationWork()
          this.showMessage('Guardado', 'alert-success')
          this.clear()
				}else{
          this.showMessage('No se pudo guardar', 'alert-danger')
        }
			}, (err) => {
        this.showMessage('No se pudo guardar', 'alert-danger')
      })
    },
    update(){
      this.defaultAxios()
			axios.put(`/workflow/working_conditions/${this.workingCondition.id}`, { working_condition: this.workingCondition }).then(res=>{
				if(res.status == 200){
          this.getInformationWork()
          this.showMessage('Registro actualizado', 'alert-success')
          this.clear()
				}else{
          this.showMessage('El registro no se pudo actualizar', 'alert-danger')
        }
			}, (err) => {
        this.showMessage('El registro no se pudo actualizar', 'alert-danger')
      })
    },    
    deleteworkingCondition(id){
      this.defaultAxios()
			axios.delete(`/workflow/working_conditions/${id}`, {}).then(res=>{
        this.getInformationWork()
				if(res.status == 200){          
          this.showMessage('Familiar eliminado', 'alert-success')
				}else{
          this.showMessage('No se pudo eliminar el familiar', 'alert-danger')
        }
			}, (err) => {
        this.showMessage('No se pudo eliminar el familiar', 'alert-danger')
      })
    },
		showMessage(message, typeMessage){
			this.message = message
			this.typeMessage = typeMessage
			setTimeout(() => this.message = '', 3000)
		},        
  },
  created () {
    this.getWorkingCondition()
  },
  watch: {
    project() {
      if (this.project != null) {
        if (this.project.working_condition != null){
          this.workingCondition = this.project.working_condition
        }
      }
    }
  },
  filters: {

  },
  computed:{
    projectIdProp:{
      get(){
        return this.project_id
      }
    },
    assignmentIdProp:{
      get(){
        return this.assignment_id
      }
    },
    project:{
      get(){
        return this.$store.state.project
      }
    }
  }
}
</script>

<style scoped>
.question-text{
  padding-bottom: 1rem;
}
.question-boolean{
  padding-bottom: 1rem;
}
</style>